import { BaseModel } from '../base-model'
import { WorklistSessionData } from './worklist-session.data'

export class WorklistSessionModel extends BaseModel {
  constructor(data?: WorklistSessionData) {
    super(data, true)
  }

  override toJSON() {
    return {
      id: this.id,
    }
  }
}
